import * as action from '../store/action-types'

function overlayDataProp (key, options) {
  options = Object.assign({}, options)
  return {
    get: function () {
      const value = this.$store.getters.overlayData(this.templateId)[key] || options.default
      return (value === null || value === undefined) ? options.default : value
    },
    set: function (val) {
      // For reasons, I couldn't figure out, the component b-form-select may emit undefined instead an empty string.
      if (val === undefined) {
        val = options.default
      }
      // Undefined is a dangerous value because it will cause the property to be missing in the JSON strings.
      if (val === undefined) {
        val = null
      }
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: {[key]: val}
      })
    }
  }
}

export default overlayDataProp



// WEBPACK FOOTER //
// ./src/utils/overlayDataProp.js